import React, { useEffect, useRef } from 'react'
import Logo from '../assets/images/MCL SCHOOL BG REMOVE SMALL COLOURFULL 2.png'
import { Link, useLocation } from 'react-router'

const Header = () => {
    // const location = useLocation();
    // const buttonRef = useRef(null);

    // useEffect(() => {
    //     // Trigger the button click on location change
    //     const offcanvas = document.querySelector(".offcanvas");
    //     const nav = document.querySelector("nav");
    //     const backdrop = document.querySelector(".offcanvas-backdrop.fade.show");
    //     // Remove the 'show' class from the offcanvas element
    //     if (offcanvas) {
    //         offcanvas.classList.remove("show");
    //     }
    //     if (backdrop) {
    //         backdrop.remove();
    //       }
    //     // Remove 'padding-right' from the nav element
    //     if (nav) {
    //         nav.style.paddingRight = "";
    //     }
    //     // Remove overflow and padding-right styles from body
    //     document.body.style.overflow = "";
    //     document.body.style.paddingRight = "";

    //     // Optional: Cleanup logic for other conditions if needed
    //     return () => {
    //         document.body.style.overflow = "";
    //         document.body.style.paddingRight = "";
    //     };
    // }, [location]);
    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top">
                <div className="container-fluid px-4">
                    <div>
                        <Link className="navbar-brand text-danger mt-5" to={'/'}>
                            <img width={150} src={Logo} alt='logo' />
                        </Link>
                    </div>
                    <button  className="navbar-toggler" type="button" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample">
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className="offcanvas offcanvas-start" tabIndex={-1} id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
                        <div class="offcanvas-header justify-content-end">
                            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        <div className="offcanvas-body">
                            <div className="d-flex justify-content-lg-end w-100">
                                <div className="dropdown mt-2 me-3">
                                    <button className="btn btn-light dropdown-toggle" type="button" id="programsDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                        Programs
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="programsDropdown">
                                        <li><Link className="dropdown-item" to="/salesforce">Salesforce</Link></li>
                                        <li><Link className="dropdown-item" to="/devops">DevOps</Link></li>
                                        <li><Link className="dropdown-item" to="/web-devlopement">Web Development</Link></li>
                                        <li><Link className="dropdown-item" to="/app-development">App Development</Link></li>
                                        <li><Link className="dropdown-item" to="/cloud-computing">Cloud Computing</Link></li>
                                    </ul>
                                </div>
                                <div className="buttons-main mt-3">
                                    {/* Programs Dropdown */}
                                    <Link id="req-demo" to={'/enroll-now'}>ENROLL NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

        </>
    )
}

export default Header